__webpack_require__.p = "https://static.age.awaze.com/search-mfe/af272e8/_next/";